<div class="flex flex-col items-start gap-4 md:flex-row">
  <nav class="help-nav w-full shrink-0 md:w-64">
    <ul>
      @for (item of navItems; track item.link) {
        <li>
          @if (item.children) {
            <details open>
              <summary>
                <span>{{ item.labelKey | translate }}</span>
                <i class="fal fa-angle-down"></i>
              </summary>
              <ul>
                @for (child of item.children; track child.link) {
                  <li>
                    <a [routerLink]="child.link" routerLinkActive="active">{{ child.labelKey | translate }}</a>
                  </li>
                }
              </ul>
            </details>
          } @else {
            <a [routerLink]="item.link" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active">
              {{ item.labelKey | translate }}
            </a>
          }
        </li>
      }
    </ul>
  </nav>

  <p-card class="w-full min-w-0 flex-1">
    <router-outlet />
  </p-card>
</div>
